import css from 'styled-jsx/css';

export const onboardingModalStyles: (isDesktop: boolean) => ReactModal.Styles = (
  isDesktop: boolean
) => ({
  content: {
    height: '100%',
    width: '100%',
    inset: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    padding: isDesktop ? '20px' : 0,
    borderRadius: isDesktop ? 'auto' : 0,
  },
  overlay: {
    zIndex: 1000,
    overflow: 'hidden',
  },
});

export default css`
  .modal-header {
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0.2px;
    margin: 16px 16px;
    text-align: center;
  }
  .modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .modal-subtext {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-align: center;
    margin: 16px 0 42px 0;
  }
  .autolist-logo {
    height: 36px;
    width: 36px;
  }
  .close-button {
    cursor: pointer;
    align-self: end;
  }
`;
